(function ($) {
  ("use strict");

  function showNotification(title, message, duration) {
    $(".custom-toast").remove();
    // Создаем уведомление динамически
    var notification = $(`
    <div class="custom-toast d-flex justify-content-center align-items-center" aria-live="polite" aria-atomic="true" data-autohide="true">
      <div class="toast show fade" role="alert" aria-live="assertive" aria-atomic="true" data-delay="${duration}">
        <div class="toast-header">
          <strong class="mr-auto">${title}</strong>
          <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="toast-body">
          ${message}
        </div>
      </div>
    </div>
  `);

    // Вставляем уведомление после тега header
    $("header").after(notification);

    // Показываем уведомление
    notification.find(".toast").toast("show");
  }

  $(document).on("classChanged", ".sub-drop-menu", function (event, className) {
    var expanded = $(this).parent().attr("aria-expanded");
    var expanded_a = $(this).parent().find("a").attr("aria-expanded");
    if (expanded == "false") {
      $(this).parent().attr("aria-expanded", "true");
    } else {
      $(this).parent().attr("aria-expanded", "false");
    }
    if (expanded_a == "false") {
      $(this).parent().find("a").attr("aria-expanded", "true");
    } else {
      $(this).parent().find("a").attr("aria-expanded", "false");
    }

    if (className == "something") {
      /* do something */
    }
  });

  $("body").on("click", ".card-img-overlay", function (e) {
    var id = e.target.id;
    var tclass = $(e.target).attr("class");
    if (!id) {
      window.location.href = $(this).find(".add-to-cart").attr("href");
    }
  });

  $("body").on("click", ".card-img-overlay2", function (e) {
    var id = e.target.id;
    var tclass = $(e.target).attr("class");
    if (tclass == "card-img-overlay2 d-flex p-3 flex-column") {
      var loc_name = $(this).find(".prod_link").attr("loc_name");
      var chosen = $("#dropdown-location").html();
      if (
        chosen.indexOf(loc_name) == -1 &&
        chosen.indexOf("All locations") == -1
      ) {
        let confirmAction = confirm(
          "The location of this product is different than your chosen location. Continue?"
        );
        if (confirmAction) {
          window.location.href = $(this).find(".prod_link").attr("href");
        }
      } else {
        window.location.href = $(this).find(".prod_link").attr("href");
      }
    } else {
    }
  });

  $("body").on("click", ".prod_link", function (e) {
    e.preventDefault();
    var loc_name = $(this).attr("loc_name");
    var chosen = $("#dropdown-location").html();
    if (
      chosen.indexOf(loc_name) == -1 &&
      chosen.indexOf("All locations") == -1
    ) {
      let confirmAction = confirm(
        "The location of this product is different than your chosen location. Continue?"
      );
      if (confirmAction) {
        window.location.href = $(this).attr("href");
      } else {
        $(this).parent().find(".tooltip").hide();
      }
    } else {
      window.location.href = $(this).attr("href");
    }
  });

  $("body").on("mouseover", ".prod_link", function (e) {
    $(".tooltip").hide();
    $(this).parent().find(".tooltip").show();
  });

  $("body").on("click", ".aj_pagination a", function (e) {
    e.preventDefault();
    var warecat_id = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .attr("warecat_id");
    var ware_ids = $(this).parent().parent().parent().parent().attr("ware_ids");

    //build action url
    var action = $(this).attr("href");
    var split2 = action.split("page=");
    var page = Number(split2[1]);
    if (page < 1) {
      page = 1;
    }

    //deactivate +add 1
    var i = 0;
    $(".pag_" + warecat_id + " li").each(function (index) {
      if (index == 0) {
        $(this).removeClass("disabled");
        $(this).attr("aria-disabled", "false");
        $(this).html(
          '<a class="page-link" href="?page=' +
            (page - 1) +
            '" rel="prev" aria-label="« Previous">‹</a>'
        );
      }
      if (index == 1) {
        $(this).html('<a class="page-link" href="/?page=1">1</a>');
      }

      $(this).removeClass("active");
      i++;
    });

    if (page == 1) {
      $(".pag_" + warecat_id + " li").each(function (index) {
        if (index == 0) {
          $(this).attr("aria-disabled", "true");
          $(this).addClass("disabled");
          $(this).html('<span class="page-link" aria-hidden="true">‹</span>');
        }
      });
    }

    var max = i - 2;
    if (page == max) {
      $(".pag_" + warecat_id + " li").each(function (index) {
        m = max + 1;
        if (index == m) {
          $(this).addClass("disabled");
          $(this).html('<span class="page-link" aria-hidden="true">›</span>');
        }
      });
    }

    //activate
    $(".pag_" + warecat_id + " li").each(function (index) {
      if ($(this).find("a").attr("rel") == "next") {
        var html = $(this).html();
        o = html.split("page=");
        n = o[1].split('"');
        pg = n[0];
        $(this).html(html.replace(pg, page + 1));
        $(this).removeClass("disabled");
      }
      if (index == page) {
        $(this).addClass("active");
      }
    });

    // remove active .. add active, add 1

    var aurl = "/ajshow";
    $.ajax({
      url: aurl,
      method: "POST",
      data: {
        ware_ids: ware_ids,
        page: page,
        _token: $("input[name=_token]").val(),
      },
      success: function (data) {
        $(".loc_" + warecat_id).fadeOut(400, function () {
          $(this).html(data).fadeIn(400);
        });

        document.getElementById("title_" + warecat_id).scrollIntoView();
      },
    });
  });

  $("body").on("click", ".osearch .input-group-text", function (e) {
    e.preventDefault();
    if ($("form#allsearch #keyword").val().length < 3) {
      $(".s-error").show();
      setTimeout(function () {
        $(".s-error").hide();
      }, 3000);
    } else {
      $("form#allsearch").submit();
    }
  });

  $("body").on("click", "form#add_checkout1 .btn_submit", function (e) {
    e.preventDefault();
    var err = 0;

    if ($("form#add_checkout1 input[name=email]").length) {
      $("form#add_checkout1 input[name=email]").removeClass("is-invalid");

      if (!$("form#add_checkout1 input[name=email]").val()) {
        $("form#add_checkout1 input[name=email]").addClass("is-invalid");

        if (!err) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("form#add_checkout1 input[name=email]").offset().top - 180,
            },
            500
          );
        }

        err = 1;
      }
    }

    if ($("form#add_checkout1 .address_unregistered_form").length) {
      $("form#add_checkout1 .address_unregistered_form input[required]")
        .filter(function () {
          return $(this).val() == "";
        })
        .removeClass("is-invalid");
      $("form#add_checkout1 .address_unregistered_form select[required]")
        .filter(function () {
          return $(this).val() == "";
        })
        .removeClass("is-invalid");

      if (
        $(
          "form#add_checkout1 .address_unregistered_form input[required]"
        ).filter(function () {
          return $(this).val() == "";
        }).length
      ) {
        $("form#add_checkout1 .address_unregistered_form input[required]")
          .filter(function () {
            return $(this).val() == "";
          })
          .addClass("is-invalid");

        if (!err) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(".address_unregistered_form").offset().top - 180,
            },
            500
          );
        }

        err = 1;
      }
    }

    if ($("form#add_checkout1 .no-shipping").length) {
      $(".no-shipping .card-content-wrapper").css("border", "1px solid red");

      if (!err) {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $(".no-shipping").offset().top - 180,
          },
          500
        );
      }

      err = 1;
    }

    //let's allow all
    if (
      !$(this)
        .parent()
        .find("input[name=paymentMethod]")
        .filter("input:checked").length
    ) {
      $(".radio-card").css("border", "1px solid red");

      err = 1;
    }

    if (err == 0) {
      $("form#add_checkout1").submit();
    }
  });

  $("body").on(
    "change",
    "#radio-payment-0,#radio-payment-1,#radio-payment-2,#radio-payment-3,#radio-payment-4",
    function (e) {
      $(".radio-card").css("border", "0px solid grey");
    }
  );

  $("body").on("submit", "form#address_add_aj", function (e) {
    e.preventDefault();
    var formData = new FormData(this);
    var action = $(this).prop("action");
    $.ajax({
      url: action,
      type: "POST",
      data: formData,
      success: function (data) {
        $(".ship_area").html(data);
        $(".close").click();
      },
      cache: false,
      contentType: false,
      processData: false,
    });
  });

  $("body").on("click", ".currency_selector", function (e) {
    e.preventDefault();
    var curr = $(this).attr("curr");
    $.ajax({
      url: "/currencyset",
      method: "POST",
      data: {
        curr: curr,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function (data) {
        location.reload();
      },
    });
  });

  $("body").on("submit", "form#newsletter_form", function (e) {
    e.preventDefault();
    var formData = new FormData(this);
    var action = $(this).prop("action");
    $.ajax({
      url: action,
      type: "POST",
      data: formData,
      success: function (data) {
        if (data === "register") {
          window.location = "/register";
          return;
        }
        $("#newsletter_status").html(data);
        if (data.indexOf("success") !== -1) {
          $("#newsletter_form").trigger("reset");
        }
        $("#newsletter_form").remove();
      },
      cache: false,
      contentType: false,
      processData: false,
    });
  });

  var $body = $("body"),
    $window = $(window),
    $siteWrapper = $("#site-wrapper"),
    $document = $(document);
  var APP = {
    init: function () {
      this.narbarDropdownOnHover();
      this.activeSidebarMenu();
      this.reInitWhenTabShow();
      this.enablePopovers();
      this.initToast();
      this.scrollSpyLanding();
      this.scrollSpyProductImage();
      this.scrollSpyBulletOne();
      this.slickCustomNav();
      this.imageMarker();
      this.dropdownMenuCanvas();
      this.canvasCart();
      this.activeSearch();
      this.productDropdownOnHover();
      this.activeMenuListing();
      this.openCouponBox();
      this.bgVideo();
      this.ModalSlick();
      this.Payment();
    },
    isMobile: function () {
      return window.matchMedia("(max-width: 1199px)").matches;
    },
    bgVideo: function () {
      var $wrapper = $(".bg-video"),
        unit = "px";
      if ($wrapper.length < 1) {
        return;
      }
      resizeBgVideo();
      $(window).resize(function () {
        resizeBgVideo();
      });

      function resizeBgVideo() {
        var heightWrap = $wrapper.height(),
          widthWrap = $wrapper.width(),
          ratioHeight = widthWrap / (16 / 9),
          ratioWidth = heightWrap * (16 / 9),
          height = 0,
          width = 0;
        height = ratioHeight;
        if (ratioHeight < heightWrap) {
          height = heightWrap;
        }
        width = ratioWidth;
        if (ratioWidth < widthWrap) {
          width = widthWrap;
        }
        $wrapper.find("iframe").css({ height: height + unit });
        $wrapper.find("iframe").css({ width: width + unit });
      }
    },
    narbarDropdownOnHover: function () {
      var $dropdown = $(".main-header .hover-menu .dropdown");
      if ($dropdown.length < 1) {
        return;
      }
      $dropdown.on("mouseenter", function () {
        if (APP.isMobile()) {
          return;
        }
        var $this = $(this);
        $this.addClass("show").find(" > .dropdown-menu").addClass("show");
      });
      $dropdown.on("mouseleave", function () {
        if (APP.isMobile()) {
          return;
        }
        var $this = $(this);
        $this.removeClass("show").find(" > .dropdown-menu").removeClass("show");
      });
    },
    productDropdownOnHover: function () {
      var $dropdown = $(".product-dropdown");
      if ($dropdown.length < 1) {
        return;
      }
      var $dropdown_toggle = $(".product-dropdown .dropdown-toggle");
      $dropdown_toggle.on("click", function (e) {
        e.preventDefault();
        location.href = $dropdown_toggle.attr("href");
      });
      $dropdown.on("mouseenter", function () {
        var $this = $(this);
        $this.addClass("show").find(" > .dropdown-menu").addClass("show");
      });
      $dropdown.on("mouseleave", function () {
        var $this = $(this);
        $this.removeClass("show").find(" > .dropdown-menu").removeClass("show");
      });
    },
    dropdownMenuCanvas: function () {
      $(".sidenav .dropdown-menu [data-toggle='dropdown']").on(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          var that = this;
          $(that).next().toggleClass("show");
          $(this)
            .parents("li.nav-item.dropdown.show")
            .on("hidden.bs.dropdown", function (e) {
              $(that).next().removeClass("show");
            });
        }
      );
    },
    activeSidebarMenu: function () {
      var $sidebar = $(".db-sidebar");
      if ($sidebar.length < 1) {
        return;
      }
      var $current_link = window.location.pathname;
      var $sidebarLink = $sidebar.find(".sidebar-link");
      $sidebarLink.each(function () {
        var href = $(this).attr("href");
        if ($current_link.indexOf(href) > -1) {
          var $sidebar_item = $(this).parent(".sidebar-item");
          $sidebar_item.addClass("active");
        }
      });
    },
    reInitWhenTabShow: function () {
      var $tabs = $('a[data-toggle="pill"],a[data-toggle="tab"]');
      $tabs.each(function () {
        var $this = $(this);
        $this.on("shown.bs.tab", function (e) {
          var href = $(this).attr("href");
          if (href !== "#") {
            var $slider = $(href).find(".slick-slider");
            $slider.slick("setPosition");
            $('[data-toggle="tooltip"]').tooltip("update");
            if ($(e.target).attr("href") !== undefined) {
              var $target = $($(e.target).attr("href"));
              APP.util.mfpEvent($target);
            }
          }
        });
      });
    },
    enablePopovers: function () {
      $('[data-toggle="popover"]').popover();
    },
    initToast: function () {
      $(".toast").toast();
    },
    scrollSpyLanding: function () {
      var $langding_menu = $("#landingMenu");
      if ($langding_menu.length < 1) {
        return;
      }
      $("body").scrollspy({ target: "#landingMenu", offset: 200 });
      $langding_menu
        .find(".nav-link")
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
              event.preventDefault();
              $("html, body").animate(
                { scrollTop: target.offset().top },
                500,
                function () {}
              );
            }
          }
        });
    },
    scrollSpyProductImage: function () {
      var $image_dots = $("#list-dots");
      if ($image_dots.length < 1) {
        return;
      }
      $("body").scrollspy({ target: "#list-dots", offset: 200 });
      var $scroll_images = $(".scrollspy-images");
      $window.on("scroll", function (e) {
        e.preventDefault();
        var is_end =
          $(this).scrollTop() + $(this).height() >
          $scroll_images.offset().top + $scroll_images.height() + 250;
        if (is_end) {
          $image_dots.addClass("hide");
        } else {
          $image_dots.removeClass("hide");
        }
      });
    },
    scrollSpyBulletOne: function () {
      var $bullet_dots = $("#bullet-one");
      var $nav = $(".bullet-nav");
      var $scroll_bullet = $(".scrollspy-bullet");
      if ($bullet_dots.length < 1) {
        return;
      }
      $("body").scrollspy({ target: "#bullet-one", offset: 200 });
      $window.on("scroll", function (e) {
        e.preventDefault();
        var is_end =
          $(this).scrollTop() + $(this).height() >
          $scroll_bullet.offset().top + $scroll_bullet.height() + 250;
        if (is_end) {
          $bullet_dots.addClass("hide");
        } else {
          $bullet_dots.removeClass("hide");
        }
      });
      toggle_skin_class($nav);
      $window.on("activate.bs.scrollspy", function (e, obj) {
        toggle_skin_class($nav);
      });
      $("a[href*=\\#]:not([href=\\#])").click(function () {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            $("html, body").animate({ scrollTop: target.offset().top }, 500);
            return false;
          }
        }
      });

      function toggle_skin_class($nav) {
        $nav.removeClass("nav-dark");
        $nav.removeClass("nav-light");
        var $active_element = $nav.find(".nav-link.active");
        var $skin = $active_element.data("skin");
        $nav.addClass("nav-" + $skin);
      }
    },
    ModalSlick: function () {
      var preview = $(".preview");
      preview.on("click", function (e) {
        e.preventDefault();
      });
      $(".modal").on("shown.bs.modal", function (e) {
        $(".quick-view .modal-dialog").css("opacity", "1");
        $(".view-slider-for").not(".slick-initialized").slick({
          slidesToShow: 1,
          arrows: false,
          dots: false,
          fade: true,
          asNavFor: ".view-slider-nav",
        });
        $(".view-slider-nav").not(".slick-initialized").slick({
          slidesToShow: 5,
          asNavFor: ".view-slider-for",
          dots: false,
          arrows: false,
          focusOnSelect: true,
        });
      });
    },
    Payment: function () {
      var $btn_payment = $(".btn-payment");
      var $card_box = $(".card-box");
      var $payment_card = $(".payment-card");
      var $paylay_box = $(".paylay-box");
      var $payment_paylay = $(".payment-paylay");
      /*$payment_card.on("click", function () {
          $card_box.slideDown();
          $paylay_box.slideUp();
      });
      $payment_paylay.on("click", function () {
          $paylay_box.slideDown();
          $card_box.slideUp();
      });
      */
      $btn_payment.on("click", function (e) {
        e.preventDefault();
        $btn_payment.removeClass("active");
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
        }
      });
      $(".creditCardText").keyup(function () {
        var foo = $(this).val().split("-").join("");
        if (foo.length > 0) {
          foo = foo.match(new RegExp(".{1,4}", "g")).join("-");
        }
        $(this).val(foo);
      });
    },
    slickCustomNav: function () {
      var $slickslider = $(".custom-nav");
      if ($slickslider.length < 1) {
        return;
      }
      $(".arrow").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("slick-prev")) {
          $slickslider.slick("slickPrev");
        }
        if ($(this).hasClass("slick-next")) {
          $slickslider.slick("slickNext");
        }
        $slickslider.on("afterChange", function (slick, currentSlide) {
          if (0 === currentSlide.currentSlide) {
            $("#previous").addClass("disabled");
          } else {
            $("#previous").removeClass("disabled");
          }
          if (
            currentSlide.slideCount - currentSlide.options.slidesToShow ===
            currentSlide.currentSlide
          ) {
            $("#next").addClass("disabled");
          } else {
            $("#next").removeClass("disabled");
          }
        });
      });
    },
    imageMarker: function () {
      $(".image-marker")
        .find('[data-toggle="tooltip"]')
        .each(function () {
          var configs = {
            container: $(this).parent(),
            html: true,
            placement: "top",
            offset: 20,
            delay: { show: 0, hide: 100 },
          };
          if ($(this).closest(".gtf__tooltip-wrap").length) {
            configs = $.extend(
              {},
              configs,
              $(this).closest(".gtf__tooltip-wrap").data("tooltip-options")
            );
          }
          $(this).tooltip(configs);
        });
    },
    canvasCart: function () {
      let updateBtn = $("#CartFormUpdateBtn");
      let form = $("#CartForm");
      let box = $("#CartBox");
      $("#CartForm")
        .find("select, input")
        .change(function (e) {
          form.submit();
        });
      let updating = false;
      $("#CartForm").submit(async function (e) {
        e.preventDefault();
        if (updating) {
          clearTimeout(updating);
        }
        updating = setTimeout(() => {
          $.ajax({
            url: "/cart/update",
            method: "post",
            dataType: "json",
            data: form.serialize(),
            success: function (response) {
              $.ajax({
                url: "/cart/indexForm",
                success: function (response) {
                  box.empty();
                  box.append(response);
                  APP.canvasCart();
                  form = $("#CartForm");
                  showNotification("Cart updated", "Cart updated", 3000);
                  updating = false;
                },
              });
            },
          });
        }, 1000);
      });
      $("input[product_set]").change(function () {
        let $input = $(this);
        let $value = parseInt($input.val());
        let productSetId = $input.attr("product_set");
        $(`input[product_set=${productSetId}]`).each(function () {
          let $input = $(this);
          let amount = $input.attr("amount");
          $(this).val(parseInt($value * amount));
        });
        form.submit();
      });
      $("select[product_set]").change(function () {
        let select = $(this);
        let value = parseInt(select.val());
        let productSetId = select.attr("product_set");
        let selectedIndex = select.attr("selectedIndex");
        $(`select[product_set=${productSetId}]`).each(function () {
          let select = $(this);
          select.attr("selectedIndex", selectedIndex);
          select.val(value);
        });
        form.submit();
      });
      $(".down").on("click", function (e) {
        e.preventDefault();
        var $parent = $(this).parent(".input-group");
        var $input = $parent.find("input");
        var $value = parseInt($input.val());

        if ($input.attr("product_set")) {
          let productSetId = $input.attr("product_set");
          $(`input[product_set=${productSetId}]`).each(function () {
            let $input = $(this);
            let $value = parseInt($input.val());
            let amount = $input.attr("amount");
            if ($value > 0) {
              $value -= parseInt(amount);
              $input.val($value);
            }
          });
        } else {
          if ($value > 0) {
            $value -= 1;
            $input.val($value);
          }
        }
        form.submit();
      });
      $(".up").on("click", function (e) {
        e.preventDefault();
        var $parent = $(this).parent(".input-group");
        var $input = $parent.find("input");
        var $value = $input.val();

        if ($input.attr("product_set")) {
          let productSetId = $input.attr("product_set");
          $(`input[product_set=${productSetId}]`).each(function () {
            let $input = $(this);
            let $value = parseInt($input.val());
            let amount = $input.attr("amount");
            if ($value !== "") {
              $value = parseInt($value);
              $value += parseInt(amount);
              $input.val($value);
            } else {
              $input.val(parseInt(amount));
            }
          });
        } else {
          if ($value !== "") {
            $value = parseInt($value);
            $value += 1;
            $input.val($value);
          } else {
            $input.val(1);
          }
        }
        form.submit();
      });
    },
    activeSearch: function () {
      var $input = $(".input-search-event");
      var $search_section = $(".section-search-active");
      var $form_search = $(".form-search");
      var $nav_search = $(".nav-search-event");
      var $menu = $(".nav-menu");
      $("body").on("click", function (e) {
        var target = $(e.target);
        if (
          target.closest(".nav-search-event").length > 0 &&
          target.closest(".input-search").length < 1 &&
          target.closest(".section-search-active a").length < 1
        ) {
          $form_search.addClass("show");
          $nav_search.addClass("hide");
        } else if (
          target.closest(".nav-search-event").length < 1 &&
          target.closest(".input-search").length < 1 &&
          target.closest(".section-search-active a").length < 1
        ) {
          $form_search.removeClass("show");
          $nav_search.removeClass("hide");
        }

        APP.headerSticky.sticky();
      });
      $input.on("focus", function (e) {
        e.preventDefault();
        $search_section.slideDown(200);
        $menu.slideUp(200);
        APP.headerSticky.sticky();
      });
      $input.on("focusout", function (e) {
        e.preventDefault();
        $search_section.slideUp(200);
        $menu.slideDown(200);
        APP.headerSticky.sticky();
      });
      $window.resize(function () {
        if (APP.isMobile()) {
          $search_section.slideUp(200);
          $menu.slideDown(200);
          APP.headerSticky.sticky();
        }
      });
    },
    activeMenuListing: function () {
      var $menu = $(".dropdown-menu-listing");
      if ($menu.length < 1) {
        return;
      }
      var $current_link = window.location.pathname;
      var $menuLink = $menu.find(".dropdown-link");
      $menuLink.each(function () {
        var href = $(this).attr("href");
        if ($current_link.indexOf(href) > -1) {
          var $menu_item = $(this).parent(".dropdown-item");
          $menu_item.addClass("active");
        }
      });
    },
    openCouponBox: function () {
      var $couponBox = $(".box-coupon");
      var $button = $(".enter-coupon");
      $button.on("click", function (e) {
        e.preventDefault();
        $couponBox.slideToggle("slow", function () {});
      });
    },
  };
  APP.slickSlider = {
    init: function ($wrap) {
      this.slickSetup($wrap);
    },
    slickSetup: function ($wrap) {
      var $slicks;
      if ($wrap !== undefined) {
        $slicks = $wrap;
      } else {
        $slicks = $(".slick-slider");
      }
      var options_default = {
        slidesToScroll: 1,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: "50px",
        draggable: true,
        fade: false,
        focusOnSelect: false,
        infinite: false,
        pauseOnHover: false,
        responsive: [],
        rtl: false,
        speed: 300,
        vertical: false,
        prevArrow:
          '<div class="slick-prev" aria-label="Previous"><i class="far fa-chevron-left"></i></div>',
        nextArrow:
          '<div class="slick-next" aria-label="Next"><i class="far fa-chevron-right"></i></div>',
        customPaging: function (slider, i) {
          return $("<span></span>");
        },
      };
      $slicks.each(function () {
        var $this = $(this);
        if (!$this.hasClass("slick-initialized")) {
          var options = $this.data("slick-options");
          if ($this.hasClass("custom-arrows-02")) {
            options.prevArrow = $(".custom-arrows-02-prev");
            options.nextArrow = $(".custom-arrows-02-next");
          }
          if ($this.hasClass("custom-slider-02")) {
            options.customPaging = function (slider, i) {
              var $index = "";
              if (i < 9) {
                $index = "0" + (i + 1);
              } else {
                $index = i + 1;
              }
              var count = "";
              if (slider.slideCount < 9) {
                count = "0" + slider.slideCount;
              } else {
                count = slider.slideCount;
              }
              return (
                '<span class="dot">' +
                $index +
                ".</span>" +
                '<span class="dot-divider"><span class="divider-value"></span></span><span class="dot">' +
                count +
                ".</span>"
              );
            };
          }
          if ($this.hasClass("custom-slider-03")) {
            options.customPaging = function (slider, i) {
              var $index = "";
              if (i < 9) {
                $index = i + 1;
              } else {
                $index = i + 1;
              }
              var count = "";
              if (slider.slideCount < 9) {
                count = slider.slideCount;
              } else {
                count = slider.slideCount;
              }
              return (
                '<span class="dot-text">Show</span><span class="dot">' +
                $index +
                "</span>" +
                '<span class="dot-divider">/</span><span class="dot">' +
                count +
                "</span>"
              );
            };
          }
          options = $.extend({}, options_default, options);
          $this.slick(options);
          $this.on("setPosition", function (event, slick) {
            var max_height = 0;
            slick.$slides.each(function () {
              var $slide = $(this);
              if ($slide.hasClass("slick-active")) {
                if (
                  slick.options.adaptiveHeight &&
                  slick.options.slidesToShow > 1 &&
                  slick.options.vertical === false
                ) {
                  if (max_height < $slide.outerHeight()) {
                    max_height = $slide.outerHeight();
                  }
                }
              }
            });
            if (max_height !== 0) {
              $this.find("> .slick-list").animate({ height: max_height }, 500);
            }
          });
        }
      });
    },
  };
  APP.util = {
    init: function () {
      this.mfpEvent();
      this.tooltip();
      this.goDown();
    },
    mfpEvent: function ($elWrap) {
      if ($elWrap === undefined) {
        $elWrap = $("body");
      }
      $elWrap.find("[data-gtf-mfp]").each(function () {
        var $this = $(this),
          defaults = {
            type: "image",
            closeOnBgClick: true,
            closeBtnInside: false,
            mainClass: "mfp-zoom-in",
            midClick: true,
            removalDelay: 300,
            callbacks: {
              beforeOpen: function () {
                switch (this.st.type) {
                  case "image":
                    this.st.image.markup = this.st.image.markup.replace(
                      "mfp-figure",
                      "mfp-figure mfp-with-anim"
                    );
                    break;
                  case "iframe":
                    this.st.iframe.markup = this.st.iframe.markup.replace(
                      "mfp-iframe-scaler",
                      "mfp-iframe-scaler mfp-with-anim"
                    );
                    break;
                }
              },
              beforeClose: function () {
                this.container.trigger("gtf_mfp_beforeClose");
              },
              close: function () {
                this.container.trigger("gtf_mfp_close");
              },
              change: function () {
                var _this = this;
                if (this.isOpen) {
                  this.wrap.removeClass("mfp-ready");
                  setTimeout(function () {
                    _this.wrap.addClass("mfp-ready");
                  }, 10);
                }
              },
            },
          },
          mfpConfig = $.extend({}, defaults, $this.data("mfp-options"));
        var galleryId = $this.data("gallery-id");
        if (typeof galleryId !== "undefined") {
          var items = [],
            items_src = [];
          var $imageLinks = $('[data-gallery-id="' + galleryId + '"]');
          $imageLinks.each(function () {
            var src = $(this).attr("href");
            if (items_src.indexOf(src) < 0) {
              items_src.push(src);
              items.push({ src: src });
            }
          });
          mfpConfig.items = items;
          mfpConfig.gallery = { enabled: true };
          mfpConfig.callbacks.beforeOpen = function () {
            var index = $imageLinks.index(this.st.el);
            switch (this.st.type) {
              case "image":
                this.st.image.markup = this.st.image.markup.replace(
                  "mfp-figure",
                  "mfp-figure mfp-with-anim"
                );
                break;
              case "iframe":
                this.st.iframe.markup = this.st.iframe.markup.replace(
                  "mfp-iframe-scaler",
                  "mfp-iframe-scaler mfp-with-anim"
                );
                break;
            }
            if (-1 !== index) {
              this.goTo(index);
            }
          };
        }
        $this.magnificPopup(mfpConfig);
      });
    },
    tooltip: function ($elWrap) {
      if ($elWrap === undefined) {
        $elWrap = $("body");
      }
      $elWrap.find('[data-toggle="tooltip"]').each(function () {
        var configs = { container: $(this).parent() };
        if ($(this).closest(".gtf__tooltip-wrap").length) {
          configs = $.extend(
            {},
            configs,
            $(this).closest(".gtf__tooltip-wrap").data("tooltip-options")
          );
        }
        $(this).tooltip(configs);
      });
    },
    goDown: function () {
      var $goDown = $(".go-down");
      if ($goDown.length > 0) {
        $goDown.on("click", function (event) {
          event.preventDefault();
          $("html, body").animate(
            { scrollTop: $("#section-next").offset().top },
            1000,
            function () {}
          );
        });
      }
    },
  };
  APP.CollapseTabsAccordion = {
    init: function () {
      this.CollapseSetUp();
    },
    CollapseSetUp: function () {
      var $tabs = $(".collapse-tabs");
      $tabs
        .find(".tab-pane.active .collapse-parent")
        .attr("data-toggle", "false");
      $tabs.find(".nav-link").on("show.bs.tab", function (e) {
        if (!$(this).hasClass("nested-nav-link")) {
          var $this_tab = $(this).parents(".collapse-tabs");
          var $tabpane = $($(this).attr("href"));
          $this_tab.find(".collapsible").removeClass("show");
          $this_tab.find("collapse-parent").addClass("collapsed");
          $this_tab.find("collapse-parent").attr("data-toggle", "collapse");
          $tabpane.find(".collapse-parent").removeClass("collapsed");
          $tabpane.find(".collapse-parent").attr("data-toggle", "false");
          $tabpane.find(".collapsible").addClass("show");
        }
      });
      $tabs.find(".collapsible").on("show.bs.collapse", function () {
        var $this_tab = $(this).parents(".collapse-tabs"),
          $parent = $(this).parents(".tab-pane.tab-pane-parent"),
          $id = $parent.attr("id"),
          $navItem = $this_tab.find(".nav-link"),
          $navItemClass = "active";
        $this_tab.find(".collapse-parent").attr("data-toggle", "collapse");
        $parent.find(".collapse-parent").attr("data-toggle", "false");
        var $tab_pane = $this_tab.find(".tab-pane");
        if (!$tab_pane.hasClass("nested-tab-pane")) {
          $this_tab.find(".tab-pane").removeClass("show active");
        }
        $parent.addClass("show active");
        var $nav_link = $parent.parents(".collapse-tabs").find(".nav-link");
        if (!$nav_link.hasClass("nested-nav-link")) {
          $nav_link.removeClass("active");
        }
        $navItem.each(function () {
          if (!$(this).hasClass("nested-nav-link")) {
            $(this).removeClass("active");
            if ($(this).attr("href") === "#" + $id) {
              $(this).addClass($navItemClass);
            }
          }
        });
      });
    },
  };
  APP.animation = {
    delay: 100,
    itemQueue: [],
    queueTimer: null,
    $wrapper: null,
    init: function () {
      var _self = this;

      if (window.innerWidth < 768) {
        console.log("Анимация отключена");
        return;
      }

      _self.$wrapper = $body;
      _self.itemQueue = [];
      _self.queueTimer = null;
      if (typeof delay !== "undefined") {
        _self.delay = delay;
      }
      _self.itemQueue["animated_0"] = [];
      $body
        .find("#content")
        .find(">div,>section")
        .each(function (index) {
          $(this).attr("data-animated-id", index + 1);
          _self.itemQueue["animated_" + (index + 1)] = [];
        });
      setTimeout(function () {
        _self.registerAnimation();
      }, 200);
    },
    registerAnimation: function () {
      var _self = this;
      $("[data-animate]:not(.animated)", _self.$wrapper).waypoint(
        function () {
          var _el = this.element ? this.element : this,
            $this = $(_el);
          if ($this.is(":visible")) {
            var $animated_wrap = $this.closest("[data-animated-id]"),
              animated_id = "0";
            if ($animated_wrap.length) {
              animated_id = $animated_wrap.data("animated-id");
            }
            _self.itemQueue["animated_" + animated_id].push(_el);
            _self.processItemQueue();
          } else {
            $this.addClass($this.data("animate")).addClass("animated");
          }
        },
        { offset: "90%", triggerOnce: true }
      );
    },
    processItemQueue: function () {
      var _self = this;
      if (_self.queueTimer) return;
      _self.queueTimer = window.setInterval(function () {
        var has_queue = false;
        for (var animated_id in _self.itemQueue) {
          if (_self.itemQueue[animated_id].length) {
            has_queue = true;
            break;
          }
        }
        if (has_queue) {
          for (var animated_id in _self.itemQueue) {
            var $item = $(_self.itemQueue[animated_id].shift());
            $item.addClass($item.data("animate")).addClass("animated");
          }
          _self.processItemQueue();
        } else {
          window.clearInterval(_self.queueTimer);
          _self.queueTimer = null;
        }
      }, _self.delay);
    },
  };
  APP.headerSticky = {
    scroll_offset_before: 0,
    init: function () {
      this.sticky();
      this.scroll();
      this.resize();
      this.processSticky();
    },
    sticky: function () {
      $(".header-sticky .sticky-area").each(function () {
        var $this = $(this);
        if (!$this.is(":visible")) {
          return;
        }
        if (!$this.parent().hasClass("sticky-area-wrap")) {
          $this.wrap('<div class="sticky-area-wrap"></div>');
        }
        var $wrap = $this.parent();
        var $nav_dashbard = $(".dashboard-nav");
        $wrap.height($this.outerHeight());
        if (window.matchMedia("(max-width: 1199px)").matches) {
          $nav_dashbard.addClass("header-sticky-smart");
        } else {
          $nav_dashbard.removeClass("header-sticky-smart");
        }
      });
    },
    resize: function () {
      $window.resize(function () {
        APP.headerSticky.sticky();
        APP.headerSticky.processSticky();
      });
    },
    scroll: function () {
      $window.on("scroll", function () {
        APP.headerSticky.processSticky();
      });
    },
    processSticky: function () {
      var current_scroll_top = $window.scrollTop();
      var $parent = $(".main-header");
      var is_dark = false;
      if (
        $parent.hasClass("navbar-dark") &&
        !$parent.hasClass("bg-secondary")
      ) {
        is_dark = true;
      }
      $(".header-sticky .sticky-area").each(function () {
        var $this = $(this);
        if (!$this.is(":visible")) {
          return;
        }
        var $wrap = $this.parent(),
          sticky_top = 0,
          sticky_current_top = $wrap.offset().top,
          borderWidth = $body.css("border-width");
        if (borderWidth !== "") {
          sticky_top += parseInt(borderWidth);
        }
        if (sticky_current_top - sticky_top < current_scroll_top) {
          $this.css("position", "fixed");
          $this.css("top", sticky_top + "px");
          $wrap.addClass("sticky");
          if (is_dark) {
            $parent.removeClass("navbar-dark");
            $parent.addClass("navbar-light");
            $parent.addClass("navbar-light-sticky");
          }
        } else {
          if ($parent.hasClass("navbar-light-sticky")) {
            $parent.addClass("navbar-dark");
            $parent.removeClass("navbar-light");
            $parent.removeClass("navbar-light-sticky");
          }
          if ($wrap.hasClass("sticky")) {
            $this.css("position", "").css("top", "");
            $wrap.removeClass("sticky");
          }
        }
      });
      if (APP.headerSticky.scroll_offset_before > current_scroll_top) {
        $(".header-sticky-smart .sticky-area").each(function () {
          if ($(this).hasClass("header-hidden")) {
            $(this).removeClass("header-hidden");
          }
        });
      } else {
        $(".header-sticky-smart .sticky-area").each(function () {
          var $wrapper = $(this).parent();
          if ($wrapper.length) {
            if (
              APP.headerSticky.scroll_offset_before >
                $wrapper.offset().top + $(this).outerHeight() &&
              !$(this).hasClass("header-hidden")
            ) {
              $(this).addClass("header-hidden");
            }
          }
        });
      }
      APP.headerSticky.scroll_offset_before = current_scroll_top;
    },
    footerBottom: function () {
      var $main_footer = $(".footer");
      var $wrapper_content = $("#content");
      $main_footer.css("position", "");
      $wrapper_content.css("padding-bottom", "");
      if ($body.outerHeight() < $window.outerHeight()) {
        $main_footer.css("position", "fixed");
        $main_footer.css("bottom", "0");
        $main_footer.css("left", "0");
        $main_footer.css("right", "0");
        $main_footer.css("z-index", "0");
        $wrapper_content.css(
          "padding-bottom",
          $main_footer.outerHeight() + "px"
        );
      } else {
        $main_footer.css("position", "");
        $wrapper_content.css("padding-bottom", "");
      }
    },
  };
  APP.sidebarSticky = {
    init: function () {
      var header_sticky_height = 0;
      if (window.matchMedia("(max-width: 767px)").matches) {
        return;
      }
      if ($("#site-header.header-sticky").length > 0) {
        header_sticky_height = 60;
      }
      $(".primary-sidebar.sidebar-sticky > .primary-sidebar-inner").hcSticky({
        stickTo: "#sidebar",
        top: header_sticky_height + 30,
      });
      $(".primary-map.map-sticky > .primary-map-inner").hcSticky({
        stickTo: "#map-sticky",
        top: header_sticky_height,
      });
      $(".primary-summary.summary-sticky > .primary-summary-inner").hcSticky({
        stickTo: "#summary-sticky",
        top: header_sticky_height,
      });
      $(".primary-gallery.summary-sticky > .primary-summary-inner").hcSticky({
        stickTo: "#summary-sticky",
        top: header_sticky_height,
      });
      $(".form-review-sticky.summary-sticky > .form-review-inner").hcSticky({
        stickTo: "#form-review-sticky",
        top: header_sticky_height,
      });
    },
  };
  APP.countdown = {
    init: function () {
      var $countDownEl = $("[data-countdown]");
      if ($countDownEl.length < 1) {
        return;
      }
      var $endTime = $countDownEl.data("countdown-end");
      var countDownDate = new Date($endTime).getTime();
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        $(".day").html(days);
        $(".hour").html(("0" + hours).slice(-2));
        $(".minute").html(("0" + minutes).slice(-2));
        $(".second").html(("0" + seconds).slice(-2));
        if (distance < 0) {
          clearInterval(x);
        }
      }, 1000);
    },
  };
  APP.canvas = {
    init: function () {
      var options_default = { container: ".canvas-sidebar" };
      var $canvas_buttons = $("[data-canvas]");
      $canvas_buttons.each(function () {
        var $this = $(this);
        var options = $this.data("canvas-options");
        options = $.extend({}, options_default, options);
        var $container = $(options.container);
        $this.on("click", function () {
          $container.addClass("show");
        });
        $container.find(".canvas-close").on("click", function () {
          $container.removeClass("show");
        });
      });
    },
  };
  APP.shopSingle = {
    init: function () {
      this.shopVariations();
      this.shopFBT();
      this.showFormReview();
      this.shopSwatchColor();
      this.scrollFormReview();
    },
    shopVariations: function () {
      var swatch = $(".shop-swatch"),
        swatchesItem = swatch.find(".swatches-item"),
        swatchesSelect = swatch.find(".swatches-select");
      if (swatch.length < 1 && swatchesItem.length < 1) {
        return;
      }
      swatchesItem.unbind("click").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass("selected")) {
          return false;
        }
        $this.parent().siblings().removeClass("selected");
        $this.parent().addClass("selected");
        swatchesSelect.val($this.attr("data-var"));
      });
    },
    shopFBT: function () {
      var FBT = $(".frequently-bought-togheter"),
        fbtItem = FBT.find(".frequently-bought-togheter-item"),
        addItem = fbtItem.find(".add-to-item");
      const originalTitle = addItem.attr("data-original-title");
      const titleAdded = addItem.attr("data-added");
      if (FBT.length < 1 && fbtItem.length < 1) {
        return;
      }
      addItem.unbind("click").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass("checked")) {
          $this.removeClass("checked");
          $this.siblings(".form-check-input").prop("checked", false);
          $this.html(
            '<svg class="icon icon-plus"><use href="/images/sprite.svg#icon-plus"></use></svg>'
          );
          switchTooltip($this, originalTitle);
        } else {
          $this.addClass("checked");
          $this.siblings(".form-check-input").prop("checked", true);
          $this.html(
            '<svg class="icon icon-check-bold"><use href="/images/sprite.svg#check-bold"></use></svg>'
          );
          switchTooltip($this, titleAdded);
        }
      });

      function switchTooltip(selector, word) {
        var toolTip = selector.siblings(".tooltip");
        if (selector.length < 1 && toolTip.length < 1) {
          return;
        }
        selector.attr("data-original-title", word);
        toolTip.find(".tooltip-inner").html(word);
      }
    },
    showFormReview: function () {
      $(".write-review").on("click", function (e) {
        var link = $(this).attr("href");
        if (link !== "#customer-review") {
          e.preventDefault();
        }
        $(".form-review").toggle("slide", { direction: "up" }, 500);
      });
      $(".btn-custom-input-file").on("click", function (e) {
        var id = "#" + $(this).attr("for");
        var filename = $(this).siblings(id);
        if (filename.length > 0) {
          filename.change(function () {
            var val = filename.val();
            if (val.substring(3, 11) === "fakepath") {
              val = val.substring(12);
            }
            if ($(this).siblings(".name-file").length > 0) {
              $(this).siblings(".name-file").html(val);
            }
          });
        }
      });
    },
    shopSwatchColor: function () {
      var swatch = $(".shop-swatch-color"),
        swatchesItem = swatch.find(".swatches-item"),
        swatchesSelect = swatch.find(".swatches-select");
      if (swatch.length < 1 && swatchesItem.length < 1) {
        return;
      }
      swatchesItem.unbind("click").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass("selected")) {
          return false;
        }
        $this.parent().siblings().removeClass("selected");
        $this.parent().addClass("selected");
        swatchesSelect.val($this.attr("data-var"));
        swatch.find("label .var").html($this.attr("data-var"));
      });
    },
    scrollFormReview: function () {
      var formReviewSticky = $("#form-review-sticky");
      if (formReviewSticky.length < 1) {
        return;
      }
      $("body").scrollspy({ target: "#form-review-sticky", offset: 200 });
      formReviewSticky
        .find(".write-review")
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
              event.preventDefault();
              $("html, body").animate(
                { scrollTop: target.offset().top },
                500,
                function () {}
              );
            }
          }
        });
    },
  };
  $(document).ready(function () {
    APP.init();
    APP.slickSlider.init();
    APP.util.init();
    APP.CollapseTabsAccordion.init();
    APP.animation.init();
    APP.headerSticky.init();
    APP.sidebarSticky.init();
    APP.countdown.init();
    APP.canvas.init();
    APP.shopSingle.init();

    window.APP = APP;
  });
})(jQuery);

(function (func) {
  $.fn.addClass = function (n) {
    // replace the existing function on $.fn
    this.each(function (i) {
      // for each element in the collection
      var $this = $(this); // 'this' is DOM element in this context
      var prevClasses = this.getAttribute("class"); // note its original classes
      var classNames = $.isFunction(n) ? n(i, prevClasses) : n.toString(); // retain function-type argument support
      $.each(classNames.split(/\s+/), function (index, className) {
        // allow for multiple classes being added
        if (!$this.hasClass(className)) {
          // only when the class is not already present
          func.call($this, className); // invoke the original function to add the class
          $this.trigger("classAdded", className); // trigger a classAdded event
        }
      });
      if (prevClasses != this.getAttribute("class"))
        $this.trigger("classChanged"); // trigger the classChanged event
    });
    return this; // retain jQuery chainability
  };
})($.fn.addClass); // pass the original function as an argument

(function (func) {
  $.fn.removeClass = function (n) {
    this.each(function (i) {
      var $this = $(this);
      var prevClasses = this.getAttribute("class");
      var classNames = $.isFunction(n) ? n(i, prevClasses) : n.toString();
      $.each(classNames.split(/\s+/), function (index, className) {
        if ($this.hasClass(className)) {
          func.call($this, className);
          $this.trigger("classRemoved", className);
        }
      });
      if (prevClasses != this.getAttribute("class"))
        $this.trigger("classChanged");
    });
    return this;
  };
})($.fn.removeClass);
